import React, { Component } from 'react';
import check from '../icons/check.svg';
import './submitButton.css'

class SubmitButton extends Component {

  state = {
    className: "submit-button",
    label: `${this.props.label}`,
    height: '',
    width: '',
    buttonEnabled: true,
  }

  flashButton() {
    this.setState({className: this.state.className + ' button-small', label: ""})
  }

  handleSubmit() {

    this.setState({buttonEnabled: false})

    const timeout = 1000

    if (this.state.buttonEnabled === true) {

      this.flashButton()

      this.props.disableButtons(timeout)

      this.timer = setTimeout(() => {
        this.props.action(timeout)

      }, timeout)
    }
  }

  componentDidMount() {
    const height = this.divElement.clientHeight;
    const width = this.divElement.clientWidth;
    this.setState({ height: height, width: width });
  }

  render() {

    return(
      <div
        ref={ (divElement) => this.divElement = divElement}
        className={this.state.className}
        onClick={() => this.state.buttonEnabled && this.handleSubmit()}
        style={{height: this.state.height-30, width: this.state.width-50}}

        >

        {this.state.label.length > 0
          ? <div>{this.state.label}</div>
          : <img src={check} alt="check" />
        }

      </div>
    )
  }
}

export default SubmitButton;
